import { useMutation, useQueryClient } from "@tanstack/react-query";
import { atom, useAtom } from "jotai";
import { atomWithQuery } from "jotai-tanstack-query";

import {
  SubmitAccessibility,
  fetchAccessibilities,
  submitAccessibility,
} from "../../apis";

const accessibilityQuery = atomWithQuery(() => ({
  queryKey: ["accessibilities"],
  queryFn: async () => {
    const response = await fetchAccessibilities();
    return {
      accessibilityNeedOptions: response.accessibility_need_options as string[],
      filterAccessibility: response.filter_accessibility as any[],
      howDoYouHearAboutOptions: response.how_do_you_hear_about_options as any[],
      data: response,
    };
  },
}));

const submitAccessibilityAtom = atom<SubmitAccessibility | null>(null);

export function useAccessibility() {
  const [{ data, isLoading, isFetching }] = useAtom(accessibilityQuery);
  const [submitData, setSubmitData] = useAtom(submitAccessibilityAtom);
  const queryClient = useQueryClient();
  const {
    mutate,
    data: mutationData,
    error,
    status,
  } = useMutation({
    mutationFn: async (args: SubmitAccessibility) => {
      return submitAccessibility(args);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["userSync"],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ["savedFilters"],
        exact: false,
      });
    },
  });

  return {
    accessibilityNeedOptions: data?.accessibilityNeedOptions || [],
    filterAccessibility: data?.filterAccessibility || [],
    howDoYouHearAboutOptions: data?.howDoYouHearAboutOptions || [],
    data: data?.data?.data,
    submitData,
    setSubmitData,
    submitAccessibility: mutate,
    submitAccessibilityResponse: mutationData,
    submitAccessibilityError: error,
    submitAccessibilityStatus: status,
    isAccessibilityLoading: isLoading || isFetching,
  };
}
